/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import ChildTraining from "components/widgets/training/PendingApprovalTraining";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { showModal } from "actions";
import TrainingDetailModal from "components/widgets/training/TrainingDetailModal";
import ApprovePendingTrainingModal from "components/widgets/training/ApprovePendingTrainingModal";
import RejectPendingTrainingModal from "components/widgets/training/RejectPendingTrainingModal";
// import { ReactComponent as SvgViewDocuments } from "components/widgets/training/view-documents.svg";
import { Trans } from "react-i18next";

class PendingApprovalTraining extends Component {
  rowClassName = "";

  state = {
    showingChildren: true,
  };

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  showDetail = (t, parentId) => {

    //ELearning ise açılmasın
    if (t.trainingMethod.value === 1)
      return;

    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: "",
      modalContent: (
        <TrainingDetailModal
          training={t}
          trainingType="pendingApproval"
          isParent={t.isParent}
          parentId={parentId}
        />
      ),
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  showApproveModal = (e, t) => {
    e.preventDefault();
    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: "Eğitim Talebi Onay",
      modalContent: <ApprovePendingTrainingModal training={t} refresh={this.props.refresh} />,
      modalFooter: null,
      // modalCustomClassName: "modal-xl ttModal",
    });
  };

  showRejectModal = (e, t) => {
    e.preventDefault();
    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: "Eğitim Talebi Red",
      modalContent: <RejectPendingTrainingModal training={t} refresh={this.props.refresh} />,
      modalFooter: null,
      // modalCustomClassName: "modal-xl ttModal",
    });
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  renderTime = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleTimeString(localStorage.getItem("i18nextLng"));
  };

  renderDateTime = (type, dateString) => {
    //1 = ELearning
    if (type !== 1)
      return (
        <>
          {this.renderDate(dateString)}
          <br />
          {this.renderTime(dateString)}
        </>
      );
    else return this.renderDate(dateString);
  };

  renderTrainingMethodIcon = (value, isParent) => {
    if (isParent) {
      let icon = "iconmford fo-icon-add";
      if (!this.state.showingChildren) icon = "iconmford fo-icon-remove";
      return (
        <td
          onClick={() => this.toggleChildren()}
          className="showGrup openCloseBtn"
          style={{
            textAlign: "left",
            color: "rgb(45, 150, 205)",
            paddingLeft: "25px",
            fontSize: "20px",
          }}
        >
          <span className={icon}></span>
        </td>
      );
    } else {
      switch (value) {
        case 1:
          return (
            <td onClick={() => this.toggleChildren()}>
              <span className="iconmford fo-icon-live-tv"></span>
            </td>
          );
        case 3:
          return (
            <td onClick={() => this.toggleChildren()} className="showGrup">
              <span className="iconmford fo-icon-tv ">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
              </span>
            </td>
          );
        default:
          return (
            <td
              onClick={() => this.toggleChildren()} // onClick={() => this.showDetail(this.props.t, this.props.parentId)}
            >
              <span className="iconmford fo-icon-class "></span>
            </td>
          );
      }
    }
  };

  renderQuota(t) {
    //1 = ELearning
    if (t.trainingMethod.value === 1)
      return (<Trans desc="Limitsiz">10512</Trans>)
    else {
      if (t.timeplans !== null && t.timeplans.length > 0)
        return (`${t.timeplans[0].availableQuota}/${t.timeplans[0].quota}`)
      else
        return null;
    }
  }

  renderChildren = (t) => {
    if (t.isParent && this.state.showingChildren === false) {
      let childTrainings = t.childTrainings.map((ct) => {
        return (
          <React.Fragment key={ct.training.id}>
            <DesktopBreakpoint>
              <ChildTraining
                key={ct.training.id}
                t={ct}
                isChild={true}
                parentId={t.training.id}
              />
            </DesktopBreakpoint>
            <TabletBreakpoint>
              <ChildTraining
                key={ct.training.id}
                t={ct}
                isChild={true}
                parentId={t.training.id}
              />
            </TabletBreakpoint>
          </React.Fragment>
        );
      });
      return (
        <>
          <DesktopBreakpoint>
            <tr>
              <td colSpan="10">
                <table width="100%">
                  <tbody>
                    <tr className="child">
                      <td className="child">
                        <table className="table">
                          <tbody>{childTrainings}</tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </DesktopBreakpoint>
          <TabletBreakpoint>
            <tr>
              <td colSpan="2" className="accordionArea">
                <div className="accordion" id="accordionDays">
                  {childTrainings}
                </div>
              </td>
            </tr>
          </TabletBreakpoint>
        </>
      );
    }
  };

  renderTabletModeDetail = (t) => {
    if (!this.state.showingChildren) {
      return (
        <tr className="child">
          <td className="child" colSpan="2">
            <table>
              <tbody>
                <tr data-dt-row="0" data-dt-column="2">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Yer">10155</Trans>
                    </div>
                  </td>
                  <td>
                    {t.trainingMethod ? t.trainingMethod.label : "label yok!"}
                  </td>
                </tr>
                <tr data-dt-row="0" data-dt-column="2">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Talep Eden Ad Soyad">10161</Trans>
                    </div>
                  </td>
                  <td>Talep Eden</td>
                </tr>
                <tr data-dt-row="0" data-dt-column="5">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Kontenjan">10162</Trans>
                    </div>
                  </td>
                  <td>
                    {this.renderQuota(t)}
                  </td>
                </tr>
                <tr data-dt-row="0" data-dt-column="3">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Süre">10156</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0 ? `${t.timeplans[0].duration}` : null}
                    <sup>
                      <Trans desc="GÜN">10388</Trans>
                    </sup>
                  </td>
                </tr>
                <tr data-dt-row="0" data-dt-column="6">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Başlangıç">10117</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? this.renderDateTime(t.trainingMethod.value, t.timeplans[0].startDate)
                      : null}
                  </td>
                </tr>
                <tr data-dt-row="0" data-dt-column="7">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Bitiş">10118</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? this.renderDateTime(t.trainingMethod.value, t.timeplans[0].endDate)
                      : null}
                  </td>
                </tr>
                <tr data-dt-row="9" data-dt-column="7">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Onayla">10160</Trans>
                    </div>
                  </td>
                  <td>
                    {/* <SvgViewDocuments
                      onClick={() => this.showDetail(t)}
                      className="training-table__icon-viewdoc"
                    /> */}
                    {this.renderActions(t)}
                  </td>
                </tr>
                {this.renderChildren(t)}
              </tbody>
            </table>
          </td>
        </tr>
      );
    } else return null;
  };

  renderActions = (t) => {
    return (
      <ul className="controlButton">
        <li>
          <a href="#" onClick={(e) => this.showApproveModal(e, t)} style={{ textDecoration: "none" }} >
            <span className="iconmford fo-icon-check"></span>
          </a>
        </li>
        <li>
          <a href="#" onClick={(e) => this.showRejectModal(e, t)} style={{ textDecoration: "none" }}>
            <span className="iconmford fo-icon-clear"></span>
          </a>
        </li>
      </ul>
    );
  };

  render() {
    const { t, isChild } = this.props;

    return (
      <>
        <DesktopBreakpoint>
          <tr className="grupEgitim" key={t.id}>
            {this.renderTrainingMethodIcon(t.trainingMethod.value, t.isParent)}
            <td
              className="showGrup"
              onClick={() => this.showDetail(t, this.props.parentId)}
            >
              {t.training.name}
            </td>

            <td className="showGrup">
              {t.trainingLocation ?? ""}
            </td>
            <td className="showGrup">{t?.employee?.name}</td>
            <td className="showGrup">
              {this.renderQuota(t)}
            </td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? `${t.timeplans[0].duration}`
                : null}
              <sup>
                <Trans desc="GÜN">10388</Trans>
              </sup>
            </td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? this.renderDateTime(t.trainingMethod.value, t.timeplans[0].startDate)
                : null}
            </td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? this.renderDateTime(t.trainingMethod.value, t.timeplans[0].endDate)
                : null}
            </td>
            <td>{this.renderActions(t)}</td>
            <td style={{ display: "none" }}></td>
          </tr>
          {this.renderChildren(t)}
        </DesktopBreakpoint>
        <TabletBreakpoint>
          {isChild ? (
            <div
              key={t.training.id}
              className="card"
              style={{ marginBottom: "0" }}
            >
              <div className="card-header">
                <a className="btn btn-link" type="button">
                  <h2 className="mb-0">{t.training.name}</h2>
                </a>
              </div>
            </div>
          ) : (
            <tr key={t.training.id} className={this.rowClassName}>
              {this.renderTrainingMethodIcon(
                t.trainingMethod.value,
                t.isParent
              )}
              <td
                onClick={() => this.showDetail(t, this.props.parentId)}
                className="showGrup"
              >
                {t.training.name}
              </td>
            </tr>
          )}
          {this.renderTabletModeDetail(t)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    application: state.application,
    modal: state.modal,
  };
};

export default connect(mapStateToProps, { showModal })(PendingApprovalTraining);